import Axios from "../utils/http-request";
import { getRequestConfiguration } from "../utils/headerHelper";
import { AxiosErrorResponse } from "../interface/api_request";
import { ApplicationPropsId } from "../interface/application";
import { JobIdProps } from "../interface/job_board";

export const apiGetApplicantsById = async (values: ApplicationPropsId) => {
  try {
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    const uri = `/applications/application/${values.applicantId}`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetApplicantionToJob = async (
  values: JobIdProps,
  page: string,
  filters: string,
) => {
  try {
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    const uri = `/applications/${values.jobId}/facility?page=${page}&${filters}`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetMedicHistory = async (medic_id: string) => {
  try {
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    const uri = `/employments/facility/${medic_id}`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiUpdateApplicationStatus = async (fieldValues: {
  status: string;
  applicationId: string;
}) => {
  const formData = new URLSearchParams();
  // Append all form fields to FormData
  Object.entries(fieldValues).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    //:id
    const uri = `/applications/update-status/${fieldValues.applicationId}`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.put(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};
